const SideDrawerButtonComponent = (props: any) => {
  const {
    buttonText,
    iconName,
    isSelected,
    handleSideDrawerButtonClick,
    customIcon,
    showUnreadDot,
  } = props;

  const sideDrawerClass = isSelected
    ? 'side-drawer-button selected'
    : 'side-drawer-button';

  return (
    <button className={sideDrawerClass} onClick={handleSideDrawerButtonClick}>
      <div className="sd-btn-inner">
        {customIcon ? (
          <div className="nav-icon custom-icon">{customIcon}</div>
        ) : (
          <div className={'nav-icon ' + iconName} />
        )}
        <div className="side-drawer-button-text">
          {buttonText}
          {showUnreadDot && <span className="sd-unread-dot" aria-label="New activity" />}
        </div>
      </div>
    </button>
  );
};

export default SideDrawerButtonComponent;
